import classnames from "classnames";
import PropTypes from "prop-types";

import useIntakeFormStore from "../../store/IntakeForm.store";
import "./proposalClient.scss";

const ProposalClient = ({ className, name, value }) => {
  const formState = useIntakeFormStore((state) => state.data.formState);

  return (
    <div className={classnames("proposal-client", className)}>
      <span
        className={classnames("proposed-name", {
          placeholder: !formState?.clientDetails?.client,
        })}
      >
        {formState?.clientDetails?.client?.replace(/[^A-Za-z0-9& ]/g, "") ||
          "Client Name"}
      </span>
    </div>
  );
};

ProposalClient.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.number,
};

export default ProposalClient;
